import {
  WorkflowTimezone,
  type WorkflowContactWindow,
} from 'src/interfaces/workflows.interface';

export function getEffectiveTimeZone(
  contactWindow: WorkflowContactWindow,
): WorkflowTimezone | undefined {
  if (contactWindow.primaryTz === WorkflowTimezone.CONTACT_LOCAL) {
    return contactWindow.fallbackTz;
  }

  return contactWindow.primaryTz;
}
